import React, { useState } from 'react'
import ExistingScrap from '../classification/ExistingScrap'
import AddScrapMaterial from '../classification/AddScrapMaterial'

function MaterialClassification() {
    const [existingScrap, setExistingScrap] = useState([])

    return (
        <div
            className="p-2 cover flex column gap-1 mt-1" style={{ boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px" }} >
            <h5 className="margin-0px">Select Classifications</h5>
            <AddScrapMaterial existingScrap={existingScrap} />
            <ExistingScrap setExistingScrap={setExistingScrap} />

        </div>
    )
}

export default MaterialClassification
